import { Select, SelectProps } from 'antd';
import { orgUnitAPI } from 'api/org-unit';
import { OrgUnit } from 'interfaces/org-unit';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/query-key.enum';
interface Props extends SelectProps<number, OrgUnit> {
  typeId?: number;
  organizationUnitId?: number;
}

const SelectOrgUnit = ({ typeId, organizationUnitId, ...props }: Props) => {
  const { isLoading, data } = useQuery(
    [QUERY_KEY.GET_ORG_UNIT_LIST, typeId],
    () => orgUnitAPI.findAllCompact({ typeId }),
  );

  return (
    <Select
      loading={isLoading}
      {...props}
      options={
        data?.rows.filter((row) => {
          if (organizationUnitId) {
            return row.id === organizationUnitId;
          }

          return row;
        }) ?? []
      }
      fieldNames={{ label: 'name', value: 'id' }}
      showSearch
      optionFilterProp="name"
    />
  );
};

export default SelectOrgUnit;
